import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserDetails } from '../../api/UserApi';
import { AppState } from 'store/AppStore';
import { IUserState } from '../../../types';

const initialState: IUserState = {
  details: null,
  authState: '',
};

//To get logged in user details
export const getUser = createAsyncThunk('user/getUserDetails', async () => {
  return getUserDetails();
});

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuthState(state, action) {
      state.authState = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUser.fulfilled, (state, action) => {
      if (!action?.payload?.error) {
        state.details = action.payload.data;
      }
    });
  },
});

export const userSettings = (state: AppState) => state;

export const { setAuthState } = userSlice.actions;

export default userSlice.reducer;
